import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  CurrentUserPreferencesActions,
  CurrentUserPreferencesSelectors,
} from '@recruitee/account-data';
import { filterBoolean } from '@recruitee/common';
import type { SupportedThemesT, Theme, ThemeName } from '@recruitee/theme';
import { SupportedThemes, ThemeUtilsService } from '@recruitee/theme';

@Injectable({ providedIn: 'root' })
export class CurrentUserPreferencesFacade {
  public activeTheme$: Observable<Theme>;
  public activeThemeName$: Observable<ThemeName>;
  public effectiveThemeName$: Observable<SupportedThemesT>;
  public pipelinePromoteBannerDismissedOfferIds$: Observable<number[]>;

  constructor(private store: Store) {
    this.activeTheme$ = this.store.select(CurrentUserPreferencesSelectors.data).pipe(
      ThemeUtilsService.findEffectiveThemeNameFromPreferences,
      map(themeName => SupportedThemes[<SupportedThemesT>themeName]),
    );

    this.activeThemeName$ = <Observable<ThemeName>>(
      this.store
        .select(CurrentUserPreferencesSelectors.data)
        .pipe(map(data => data?.preferences.theme))
    );

    this.effectiveThemeName$ = this.store
      .select(CurrentUserPreferencesSelectors.data)
      .pipe(ThemeUtilsService.findEffectiveThemeNameFromPreferences);

    this.pipelinePromoteBannerDismissedOfferIds$ = this.store
      .select(CurrentUserPreferencesSelectors.data)
      .pipe(
        filterBoolean,
        map(data => data.preferences.pipelinePromoteBannerDismissedOfferIds),
      );
  }

  public setActiveTheme(themeName: ThemeName): void {
    this.store.dispatch(CurrentUserPreferencesActions.updatePreferredTheme({ payload: themeName }));
  }

  public setPipelinePromoteBannerDismissedOfferIds(offerIds: number[]): void {
    this.store.dispatch(
      CurrentUserPreferencesActions.updatePipelinePromoteBannerDismissedOfferIds({
        payload: offerIds,
      }),
    );
  }
}
